import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconReward } from "../../../assets/icons/icons";
import { useSocket } from "../../../services/SocketContext";
import { createTranslatedRewardString } from "../../../utilities/utils";
import "./modalNewReward.scss";

type ModalNewRewardProps = {
  setShowNotification: (value: "newBid" | "newReward" | null) => void;
};

const ModalNewReward: React.FC<ModalNewRewardProps> = ({
  setShowNotification
}) => {
  const socketController = useSocket();
  const [newReward, setNewReward] = useState<NewRewardPopup | null>(null);
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);

  // useEffect(() => {
  //   const rewards: NewRewardPopup = {
  //     type: "Referral Win",
  //     bids: 5
  //   };
  //   setNewReward(rewards);
  //   // const showTime = 4000;
  //   // setTimeout(() => {
  //   //   setNewReward(rewards);
  //   //   setTimeout(() => {
  //   //     setNewReward(null);
  //   //   }, showTime);
  //   // }, showTime);

  //   // const showReward = setInterval(() => {
  //   //   setNewReward(rewards);
  //   //   setTimeout(() => {
  //   //     setNewReward(null);
  //   //   }, showTime);
  //   // }, showTime * 2);

  //   // // Clear the interval when the component is unmounted
  //   // return () => {
  //   //   clearInterval(showReward);
  //   // };
  // }, []);

  function createRewardString(reward: NewRewardPopup) {
    return `${createTranslatedRewardString(reward.type)} +${reward.bids} Blitz! 🎉`;
  }

  const handleNewReward = async (
    response:
      | { rStatus: "success"; rData: NewRewardPopup }
      | { rStatus: "error"; rData: string }
  ) => {
    console.log(response);
    if (response.rStatus === "error") {
      console.log(response.rData);
      return;
    }

    try {
      // send a desktop notification
      const notification = new Notification(t("New Reward"), {
        body: createRewardString(response.rData)
      });

      notification.onclick = () => {
        window.focus();
        // go to the reward page
        window.location.href = "/dashboard?page=rewards";
        notification.close();
      };
    } catch (error) {
      console.log(error);
    }

    setNewReward(response.rData);
    setShowNotification("newReward");
    console.log(response.rData);
  };

  useEffect(() => {
    socketController.on("new-reward", handleNewReward);
    return () => {
      socketController.off("new-reward");
    };
  }, [socketController]);

  // Handle position of the alert based on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth < 1150) {
        setIsScrolled(window.scrollY > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Close function
  const handleClose = (event?: React.MouseEvent<HTMLDivElement>) => {
    if (event) {
      // stops the click of the alert close button from also triggering the popup nav to
      // rewards functionality
      event.stopPropagation();
    }
    setNewReward(null);
  };

  // allow alert click to nav to the rewards page
  const handleCloseNav = (event: React.MouseEvent<HTMLDivElement>) => {
    window.focus();
    // go to the reward page
    window.location.href = "/dashboard?page=rewards";
    handleClose(event);
  };

  // Auto-close after 15 seconds
  useEffect(() => {
    if (newReward) {
      const timer = setTimeout(() => {
        handleClose();
        setShowNotification(null);
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, [newReward, setShowNotification]);
  return (
    <AnimatePresence>
      {newReward && (
        <motion.div
          exit={{ opacity: 0, translateX: "-100%" }}
          id="new_reward_popup"
          style={{ zIndex: 100, top: isScrolled ? "0" : "4rem" }}
          className="card fixed right-2 cursor-pointer rounded-full bg-gray-800 p-3 text-center text-sm text-base-100 opacity-90 hover:opacity-100"
          onClick={handleCloseNav}
        >
          <div
            className="absolute right-0 top-0 z-[999] h-5 w-5 cursor-pointer items-center rounded-full bg-white text-black"
            onClick={handleClose}
          >
            X
          </div>
          {/* {t("NEW BID")} */}
          <div className="flex flex-row">
            <div className="rounded-full bg-white p-2">
              <IconReward className="h-6 w-6 fill-black" />
            </div>
            <div className="m-auto ml-2 mr-1 font-bold">
              <div className="font-bold">{createRewardString(newReward)}</div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ModalNewReward;
